import React, { useState } from 'react';
import { ArrowRightIcon, CheckCircle2Icon, Loader2Icon } from 'lucide-react';
import { bookingUrl, brand, navLinks } from '../data/content';
import { scrollToSection } from '../utils/scrollToSection';
type Status = 'idle' | 'submitting' | 'success' | 'error';
export function Footer() {
  const [status, setStatus] = useState<Status>('idle');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!name.trim() || !email.includes('@')) {
      setStatus('error');
      return;
    }
    setStatus('submitting');
    const url = `${bookingUrl}?name=${encodeURIComponent(name.trim())}&email=${encodeURIComponent(email.trim())}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    window.setTimeout(() => setStatus('success'), 400);
  };
  return <footer id="book" className="bg-slate-900 py-10 text-pearl-50 sm:py-12" data-id="element-76" data-mp="2ey05vyr700df">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-77" data-mp="2evxbl2j0bl2w">
        <div className="grid gap-6 sm:gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-start lg:gap-16" data-id="element-78" data-mp="3labrlvxno6qd">
          <div data-id="element-79" data-mp="3gbqyshkqgpby">
            <h2 className="font-display text-2xl font-semibold tracking-tight sm:text-3xl" data-id="element-80" data-mp="3gca7r8seo3du">
              Book a free 30-minute consult
            </h2>
            <p className="mt-2 max-w-sm text-sm leading-relaxed text-slate-300" data-id="element-81" data-mp="3q83shfga336p">
              Let's hear what you'd like to work on!
Students and parents both welcome on the consult call.
            </p>
          </div>

          {status === 'success' ? <div role="status" className="flex items-start gap-3 rounded-2xl bg-slate-800 p-5" data-id="element-82" data-mp="33nm44yp1hk6">
              <CheckCircle2Icon className="h-6 w-6 flex-none text-butter-400" aria-hidden="true" data-id="element-83" data-mp="hs1yp7lwwkdx" />
              <p className="text-sm leading-relaxed text-slate-200" data-id="element-84" data-mp="cuiku8t4m9mi">
                <span className="font-semibold text-pearl-50" data-id="element-85" data-mp="qujmhqh7tl31">
                  The scheduler is open, {name.split(' ')[0]}.
                </span>{' '}
                Pick a time in the new tab and the confirmation goes to {email}. If it did not
                open,{' '}
                <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="font-semibold text-butter-300 underline underline-offset-4" data-id="element-86" data-mp="ytxy7mx58h1h">
                  book here
                </a>
                .
              </p>
            </div> : <form onSubmit={handleSubmit} noValidate data-id="element-87" data-mp="18lk7vetu2824">
              <div className="flex flex-col gap-3 sm:flex-row" data-id="element-88" data-mp="1clumtgzls8t4">
                <div className="flex-1" data-id="element-89" data-mp="1cnp0qbcgj0np">
                  <label htmlFor="footer-name" className="sr-only" data-id="element-90" data-mp="1hk5x1stt8lbv">
                    Your name
                  </label>
                  <input id="footer-name" type="text" value={name} onChange={e => {
                setName(e.target.value);
                if (status === 'error') setStatus('idle');
              }} placeholder="Your name" className="w-full rounded-full border border-slate-700 bg-slate-800 px-5 py-3 text-sm text-pearl-50 outline-none transition-colors placeholder:text-slate-400 focus:border-butter-400" data-id="element-91" data-mp="1ml3fm6iqfhdw" />
                </div>
                <div className="flex-1" data-id="element-92" data-mp="2ah84gub5z6ug">
                  <label htmlFor="footer-email" className="sr-only" data-id="element-93" data-mp="25nvh0ni8163a">
                    Email
                  </label>
                  <input id="footer-email" type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                if (status === 'error') setStatus('idle');
              }} placeholder="Email" className="w-full rounded-full border border-slate-700 bg-slate-800 px-5 py-3 text-sm text-pearl-50 outline-none transition-colors placeholder:text-slate-400 focus:border-butter-400" data-id="element-94" data-mp="21nv1ezjdyoun" />
                </div>
                <button type="submit" disabled={status === 'submitting'} className="inline-flex items-center justify-center gap-2 rounded-full bg-butter-400 px-6 py-3 text-sm font-semibold text-slate-950 transition-all duration-200 hover:-translate-y-0.5 hover:bg-butter-300 disabled:opacity-70" data-id="element-95" data-mp="2kfe6dbwz0czb">
                  {status === 'submitting' ? <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-96" data-mp="2rvr8xjexswhg" /> : <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-97" data-mp="2rug5jkpelqqv" />}
                  {status === 'submitting' ? 'Sending' : 'Request call'}
                </button>
              </div>
              {status === 'error' && <p role="alert" className="mt-2 pl-5 text-xs font-medium text-butter-300" data-id="element-98" data-mp="2it862zb5ijv7">
                  Add your name and a valid email address.
                </p>}
            </form>}
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-slate-700 pt-5 text-sm sm:flex-row sm:items-center sm:justify-between" data-id="element-99" data-mp="3bhvxzdqeo7hq">
          <p className="text-slate-400" data-id="element-100" data-mp="31mc40wvejivm">
            <span className="font-semibold text-pearl-50" data-id="element-101" data-mp="31lau4vq4h2fh">{brand.name}</span> · {brand.tagline} ·{' '}
            <a href={`mailto:${brand.email}`} className="transition-colors hover:text-butter-300" data-id="element-102" data-mp="36isuhxq2q9bv">
              {brand.email}
            </a>
          </p>

          <nav aria-label="Footer" className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-103" data-mp="1v5qkxmme6k17">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-slate-300 transition-colors hover:text-butter-300" data-id="element-104" data-mp="1nkwi673b58fv">
                {link.label}
              </a>)}
          </nav>
        </div>

        <p className="mt-5 text-xs text-slate-500" data-id="element-105" data-mp="1wkjl4xboqmb1">
          © {new Date().getFullYear()} {brand.name}. All rights reserved.
        </p>
      </div>
    </footer>;
}